"use strict";

exports.__esModule = true;
exports.default = void 0;

var _colors = _interopRequireDefault(require("../colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vars = {
  baseFontSizePX: '16px',
  borderRadius: '4px',
  borderWidth: '2px',
  boxShadow: "0px 2px 8px " + _colors.default.shadow,
  overlayShadow: "1px 1px 10px 0px " + _colors.default.modalShadow,
  insetboxShadow: "inset 0 2px 5px " + _colors.default.shadow,
  fontStackNormal: 'galano, sans-serif',
  fontStackBold: 'galano-bold, galano, sans-serif',
  tileBoxShadow: "2px 2px 5px " + _colors.default.shadow,
  shadowLow: "0px 2px 4px " + _colors.default.shadow,
  shadowMid: "0px 4px 16px " + _colors.default.shadow,
  shadowHigh: "0px 6px 24px " + _colors.default.shadow,
  forms: {
    standalone: {
      width: '400px'
    }
  },
  fontWeight: 700,
  modalWidths: {
    small: '450px',
    medium: '600px',
    large: '800px'
  }
};
/** @component */

var _default = vars;
exports.default = _default;